import {setToken, setRefreshToken, removeToken, removeRefreshToken, getRefreshToken} from '../../utils/auth'
import {Message} from 'element-ui'
import {setStore, getStore} from '../../utils/store'
import {isURL, validatenull} from '../../utils/validate'
import {deepClone, parseJwtPayload} from '../../utils/utils'
import {loginByUsername, loginByPhone, loginBySocial, getUserInfo, logout, refreshToken, getButtons} from '@/api/user'
import md5 from 'js-md5'
import Cookies from 'js-cookie'
import website from '../../config/website'
import { notifyCrossAppLogout } from '../../utils/crossAppLogout'

// 清除旧Cookie（兼容处理）
function clearOldCookies() {
  const removeOptions = {
    domain: website.cookieDomain,
    path: website.cookiePath || '/',
    secure: website.cookieSecure,
    sameSite: website.cookieSameSite
  };
  
  // 清除旧的Cookie名称
  Cookies.remove('saber-access-token', removeOptions);
  Cookies.remove('saber-refresh-token', removeOptions);
  Cookies.remove('datav-access-token', removeOptions);
  Cookies.remove('datav-refresh-token', removeOptions);
}

const user = {
    state: {
      tenantId: getStore({name: 'tenantId'}) || '',
      userInfo: getStore({name: 'userInfo'}) || [],
    //   permission: getStore({name: 'permission'}) || {},
      roles: [],
    //   menu: getStore({name: 'menu'}) || [],
    //   menuId: getStore({name: 'menuId'}) || [],
    //   menuAll: getStore({name: 'menuAll'}) || [],
      token: getStore({name: 'token'}) || '',
      refreshToken: getStore({name: 'refreshToken'}) || '',
    },
    actions: {
      //根据用户名登录
      LoginByUsername({commit}, userInfo) {
        return new Promise((resolve, reject) => {
          loginByUsername(userInfo.tenantId, userInfo.username, md5(userInfo.password), userInfo.type, userInfo.key, userInfo.code).then(res => {
            const data = res.data;
            // console.log(data)
            if (data.error_description) {
              Message({
                message: data.error_description,
                type: 'error'
              })
            } else {
              // 清除旧Cookie
              clearOldCookies();
              commit('SET_TOKEN', data.access_token);
              commit('SET_REFRESH_TOKEN', data.refresh_token);
              commit('SET_TENANT_ID', data.tenant_id);
              commit('SET_USER_INFO', data);
              commit('DEL_ALL_TAG');
              commit('CLEAR_LOCK');
            }
            resolve();
          }).catch(error => {
            reject(error);
          })
        })
      },
      //根据手机号登录
      //根据手机号登录
    LoginByPhone({ commit }, userInfo) {
      return new Promise((resolve,reject) => {
        loginByPhone(
          userInfo.tenantId,
          userInfo.username,
          userInfo.code,
          userInfo.key,
        ).then(res => {
          const data = res.data;
          if (data.error_description) {
            Message({
              message: data.error_description,
              type: "error"
            });
          } else {
            // 清除旧Cookie
            clearOldCookies();
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            commit("SET_TENANT_ID", data.tenant_id);
            commit("SET_USER_INFO", data);
            commit("DEL_ALL_TAG");
            commit("CLEAR_LOCK");
          }
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
      //根据第三方信息登录
    //   LoginBySocial({commit}, userInfo) {
    //     return new Promise((resolve) => {
    //       loginBySocial(userInfo.tenantId, userInfo.source, userInfo.code, userInfo.state).then(res => {
    //         const data = res.data;
    //         if (data.error_description) {
    //           Message({
    //             message: data.error_description,
    //             type: 'error'
    //           })
    //         } else {
    //           commit('SET_TOKEN', data.access_token);
    //           commit('SET_REFRESH_TOKEN', data.refresh_token);
    //           commit('SET_USER_INFO', data);
    //           commit('DEL_ALL_TAG');
    //           commit('CLEAR_LOCK');
    //         }
    //         resolve();
    //       })
    //     })
    //   },
      //获取用户信息（用于单点登录：从 Cookie token 恢复当前用户展示）
      GetUserInfo({commit}) {
        return new Promise((resolve, reject) => {
          getUserInfo().then((res) => {
            const data = res.data.data;
            // console.log(data)
            commit('SET_TENANT_ID', data.tenant_id);
            commit('SET_ROLES', data.roles);
            // 同步当前用户信息到 store，保证头部显示与 token 一致
            if (data && (data.user_name !== undefined || data.account !== undefined)) {
              commit('SET_USER_INFO', {
                user_name: data.user_name || data.real_name || data.account || '',
                avatar: data.avatar || '/img/bg/img-logo.png',
                ...data
              });
            }
            // 同步 Cookie 中的 refreshToken 到 store，保证与当前 token 配套
            const currentRefreshToken = getRefreshToken();
            if (currentRefreshToken) {
              commit('SET_REFRESH_TOKEN', currentRefreshToken);
            }
            resolve(data);
          }).catch(err => {
            reject(err);
          })
        })
      },
      //刷新token
      refreshToken({state, commit, dispatch}) {
        window.console.log('handle refresh token')
        return new Promise((resolve, reject) => {
          const effectiveTenantId = state.tenantId || getStore({ name: 'tenantId' }) || website.tenantId || '000000';

          refreshToken(state.refreshToken, effectiveTenantId).then(res => {
            const data = res.data;
            commit('SET_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            
            // 刷新 token 后，检查 userInfo 是否与新 token 一致
            // 解析新 token 获取用户标识
            const newToken = data.access_token;
            const payload = parseJwtPayload(newToken);
            const tokenAccount = payload && payload.account;
            
            // 获取当前 userInfo 的 account
            const currentUserInfo = state.userInfo;
            const currentAccount = currentUserInfo && currentUserInfo.account;
            
            // 如果 userInfo 不存在，或 account 不存在，或 account 不一致，则重新拉取 userInfo
            if (!currentUserInfo || !currentAccount || !tokenAccount || currentAccount !== tokenAccount) {
              dispatch('GetUserInfo').then(() => {
                resolve();
              }).catch(() => {
                resolve(); // 即使 GetUserInfo 失败也 resolve，避免阻塞
              });
            } else {
              resolve();
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 登出
      LogOut({commit}) {
        return new Promise((resolve, reject) => {
          logout().then(() => {
            commit('SET_TOKEN', '');
            commit('SET_REFRESH_TOKEN', '');
            commit('SET_TENANT_ID', '');
            commit('SET_USER_INFO', {});
            commit('SET_MENU', []);
            commit('SET_MENU_ID', {});
            commit('SET_MENU_ALL', []);
            commit('SET_ROLES', []);
            commit('SET_TAG_LIST', []);
            commit('DEL_ALL_TAG');
            commit('CLEAR_LOCK');
            removeToken();
            removeRefreshToken();
            sessionStorage.setItem('redirectUrl','');
            sessionStorage.setItem('isIndex','');
            // 通知其他应用清除 localStorage
            notifyCrossAppLogout();
            resolve();
          }).catch(error => {
            reject(error)
          })
        })
      },
      //注销session
      FedLogOut({commit}) {
        return new Promise(resolve => {
          commit('SET_TOKEN', '');
          commit('SET_REFRESH_TOKEN', '');
          commit('SET_TENANT_ID', '');
          commit('SET_USER_INFO', {});
          commit('SET_MENU_ID', {});
          commit('SET_MENU_ALL', []);
          commit('SET_MENU', []);
          commit('SET_ROLES', []);
          commit('SET_TAG_LIST', []);
          commit('DEL_ALL_TAG');
          commit('CLEAR_LOCK');
          removeToken();
          removeRefreshToken();
          // 通知其他应用清除 localStorage
          notifyCrossAppLogout();
          resolve();
        })
      },
      //获取顶部菜单
    //   GetTopMenu() {
    //     return new Promise(resolve => {
    //       getTopMenu().then((res) => {
    //         const data = res.data.data || [];
    //         resolve(data)
    //       })
    //     })
    //   },
      //获取系统菜单
    //   GetMenu({commit, dispatch}, topMenuId) {
    //     return new Promise(resolve => {
    //       getRoutes(topMenuId).then((res) => {
    //         const data = res.data.data
    //         let menu = deepClone(data);
    //         menu.forEach(ele => {
    //           addPath(ele, true);
    //         });
    //         commit('SET_MENU_ALL', menu)
    //         commit('SET_MENU', menu)
    //         dispatch('GetButtons');
    //         resolve(menu)
    //       })
    //     })
    //   },
      //获取系统按钮
    //   GetButtons({commit}) {
    //     return new Promise((resolve) => {
    //       getButtons().then(res => {
    //         const data = res.data.data;
    //         commit('SET_PERMISSION', data);
    //         resolve();
    //       })
    //     })
    //   },
    },
    mutations: {
      SET_TOKEN: (state, token) => {
        setToken(token);
        state.token = token;
        setStore({name: 'token', content: state.token})
      },
    //   SET_MENU_ID(state, menuId) {
    //     state.menuId = menuId;
    //     setStore({name: 'menuId', content: state.menuId})
    //   },
    //   SET_MENU_ALL: (state, menuAll) => {
    //     state.menuAll = menuAll
    //     setStore({name: 'menuAll', content: state.menuAll})
    //   },
    //   SET_MENU: (state, menu) => {
    //     state.menu = menu
    //     setStore({name: 'menu', content: state.menu})
    //     if (validatenull(menu)) return;
    //     //合并动态路由去重
    //     let menuAll = state.menuAll;
    //     menuAll = menuAll.concat(menu).reverse();
    //     let newMenu = [];
    //     for (let item1 of menuAll) {
    //       let flag = true;
    //       for (let item2 of newMenu) {
    //         if (item1.name === item2.name || item1.path === item2.path) {
    //           flag = false;
    //         }
    //       }
    //       if (flag) {
    //         newMenu.push(item1);
    //       }
    //     }
    //     state.menuAll = newMenu;
    //     setStore({name: 'menuAll', content: state.menuAll})
    //   },
      SET_REFRESH_TOKEN: (state, refreshToken) => {
        setRefreshToken(refreshToken)
        state.refreshToken = refreshToken;
        setStore({name: 'refreshToken', content: state.refreshToken})
      },
      SET_TENANT_ID: (state, tenantId) => {
        state.tenantId = tenantId;
        setStore({name: 'tenantId', content: state.tenantId})
      },
      SET_USER_INFO: (state, userInfo) => {
        if (validatenull(userInfo.avatar)) {
          userInfo.avatar = "/img/bg/img-logo.png";
        }
        state.userInfo = userInfo;
        setStore({name: 'userInfo', content: state.userInfo})
      },
      SET_ROLES: (state, roles) => {
        state.roles = roles;
      },
      SET_PERMISSION: (state, permission) => {
        let result = [];
  
        function getCode(list) {
          list.forEach(ele => {
            if (typeof (ele) === 'object') {
              const chiildren = ele.children;
              const code = ele.code;
              if (chiildren) {
                getCode(chiildren)
              } else {
                result.push(code);
              }
            }
          })
        }
  
        getCode(permission);
        state.permission = {};
        result.forEach(ele => {
          state.permission[ele] = true;
        });
        setStore({name: 'permission', content: state.permission})
      }
    }
  
  }
  export default user